import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/uvalde")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Uvalde, TX | Texas Made Shade",
      description: "Custom-welded awnings, ranch shade, patio & pergola covers, dog boxes and aluminum fabrication for Uvalde & Uvalde County. Free quotes — +1 (830) 390-9588.",
      keywords: "pergola covers Uvalde, pergola covers Texas, custom pergola covers Uvalde, aluminum pergola covers Uvalde",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Uvalde, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Uvalde and Uvalde County.",
    }),
    scripts: cityHeadScripts("Uvalde", "Uvalde County"),
  }),
  component: () => <CityHomePage city="Uvalde" region="Uvalde County" />,
});
